import { render } from "./company-parents.vue?vue&type=template&id=f9cb217e&scoped=true"
import script from "./company-parents.vue?vue&type=script&lang=js"
export * from "./company-parents.vue?vue&type=script&lang=js"

import "./company-parents.vue?vue&type=style&index=0&id=f9cb217e&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9cb217e"]])

export default __exports__